module.exports = __webpack_public_path__ + "img/no-equip.6914b3a0.png";